import { pathOr } from 'ramda';

import { VStack, Text } from '@frontend/components';

import { toReadableString } from 'utils/stringUtils';

import TextMatches from './TextMatches';

const TextMatchesCell = ({
  aliases = {},
  fsHide = [],
  excludeList,
  linkFields,
  result,
  childrenHighlightConfig,
}) => {
  const extraMatchedFields = Object.keys(
    pathOr({}, ['highlight'], result),
  ).filter((highlightField) => !excludeList.includes(highlightField));

  const childTextMatches = Object.keys(childrenHighlightConfig || {}).filter(
    (child) => pathOr(false, ['children', child], result),
  );

  if (extraMatchedFields.length === 0 && childTextMatches.length === 0) {
    return <Text color="feature.placeholder">---</Text>;
  }

  return (
    <>
      <VStack alignItems="start">
        {extraMatchedFields.map((field) => (
          <TextMatches
            key={field}
            category={aliases[field] ?? toReadableString(field)}
            fsHide={fsHide.includes(field)}
            field={field}
            results={[result]}
            resultOwnerId={result.data.ownerId}
            allowNestedLink={(linkFields || []).includes(field)}
          />
        ))}
      </VStack>
      {childTextMatches.map((child) =>
        childrenHighlightConfig[child].map(
          ({ field, key, label, showOnlyIfHighlighted = false }) => (
            <TextMatches
              key={key}
              category={label}
              field={field}
              results={pathOr(null, ['children', child], result)}
              resultOwnerId={result.data.ownerId}
              allowNestedLink={(linkFields || []).includes(key)}
              showOnlyIfHighlighted={showOnlyIfHighlighted}
            />
          ),
        ),
      )}
    </>
  );
};

export default TextMatchesCell;
